export const dataBaseColumns = [
  { value: 'material', label: 'Material' },
  { value: 'isActivated', label: 'Disponível' },
  { value: 'format', label: 'Formato' },
  { value: 'finishing', label: 'Acabamento' },
  { value: 'fabrication', label: 'Fabricação' },
  { value: 'heatTreatment', label: 'Tratamento térmico' },
  { value: 'quantity', label: 'Quantidade (pç)' },
  { value: 'totalWeight', label: 'Peso total (kg)' },
  { value: 'lengthInMm', label: 'Comprimento (mm)' },
  { value: 'dimension1', label: 'Dimensão 1' },
  { value: 'dimension2', label: 'Dimensão 2' },
  { value: 'costPerKg', label: 'Custo por Kg' },
  { value: 'costPerMm', label: 'Custo por mm' },
  { value: 'price', label: 'Custo (un)' },
  { value: 'totalCmc', label: 'CMC total' },
  { value: 'originCountry', label: 'País de Origem' },
  { value: 'supplier', label: 'Fornecedor' },
  { value: 'stockStreet', label: 'Rua do Estoque' },
  { value: 'shelf', label: 'Prateleira' },
  { value: 'stockLocation', label: 'Localização' },
  { value: 'density', label: 'Densidade' },
  { value: 'totalCost', label: 'Custo total' },
  { value: 'code', label: 'Código' },
  { value: 'ncm', label: 'NCM' },
  { value: 'receivedDate', label: 'Data de recebimento' },
  { value: 'heatNumber', label: 'Nº de corrida' },
  { value: 'trackingNumber', label: 'Nº de rastreamento' },
  { value: 'family', label: 'Família' },
  { value: 'description', label: 'Descrição' },
  { value: 'characteristic', label: 'Característica' },
  { value: 'purchaseOrder', label: 'Ordem de compra' },
  { value: 'markup', label: 'Markup' },
  { value: 'color', label: 'Cor' },
  { value: 'status', label: 'Status' },
  { value: 'invoice', label: 'Nota Fiscal' },
  { value: 'certificate', label: 'Certificados' },
  { value: 'carrierCode', label: 'Código da transportadora' },
  { value: 'quantities', label: 'Conjunto de Quantidades' },
  { value: 'quantities_kg', label: 'Quantidade KG' },
  { value: 'quantities_mm', label: 'Quantidade MM' },
  { value: 'quantities_un', label: 'Quantidade UN' },
  { value: 'quantities_m2', label: 'Quantidade M²' },
  { value: 'quantities_mlinear', label: 'Quantidade M Linear' },
  { value: 'prices', label: 'Conjunto de Preço' },
  { value: 'prices_kg', label: 'Preço KG' },
  { value: 'prices_mm', label: 'Preço MM' },
  { value: 'prices_un', label: 'Preço UN' },
  { value: 'prices_m2', label: 'Preço M²' },
  { value: 'prices_mlinear', label: 'Preço M Linear' },
]

export const resourceDataBaseColumns = [
  { value: 'name', label: 'Aviamento' },
  { value: 'isActivated', label: 'Disponível' },
  { value: 'code', label: 'Código' },
  { value: 'category', label: 'Categoria' },
  { value: 'type', label: 'Tipo' },
  { value: 'color', label: 'Cor' },
  { value: 'quantities', label: 'Conjunto de Quantidades' },
  { value: 'quantities_kg', label: 'Quantidade KG' },
  { value: 'quantities_mm', label: 'Quantidade MM' },
  { value: 'quantities_un', label: 'Quantidade UN' },
  { value: 'quantities_m2', label: 'Quantidade M²' },
  { value: 'quantities_mlinear', label: 'Quantidade M Linear' },
  { value: 'quantities_percent', label: 'Quantidade %' },
  { value: 'quantities_liters', label: 'Quantidade Litros' },
  { value: 'prices', label: 'Conjunto de Preço' },
  { value: 'prices_kg', label: 'Preço KG' },
  { value: 'prices_mm', label: 'Preço MM' },
  { value: 'prices_un', label: 'Preço UN' },
  { value: 'prices_m2', label: 'Preço M²' },
  { value: 'prices_mlinear', label: 'Preço M Linear' },
  { value: 'prices_percent', label: 'Preço %' },
  { value: 'prices_liters', label: 'Preço Litros' },
  { value: 'minQuantity', label: 'Estoque Mínimo' },
  { value: 'maxQuantity', label: 'Estoque Máximo' },
  { value: 'supplier', label: 'Fornecedor' },
  { value: 'description', label: 'Descrição' },
  { value: 'dimension1', label: 'Dimensão 1' },
  { value: 'dimension2', label: 'Dimensão 2' },
  { value: 'material', label: 'Material' },
  { value: 'format', label: 'Formato' },
  { value: 'finishing', label: 'Acabamento' },
  { value: 'fabrication', label: 'Fabricação' },
  { value: 'ncm', label: 'NCM' },
  { value: 'shelf', label: 'Prateleira' },
  { value: 'stockLocation', label: 'Localização' },
  { value: 'stockStreet', label: 'Rua do Estoque' },
  { value: 'invoice', label: 'Nota Fiscal' },
  { value: 'markup', label: 'Markup' },
  { value: 'measurementUnit', label: 'Unidade' },
  { value: 'status', label: 'Status' },
]
